import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import "./styles.css";
import { BlurWrapper } from "../../Utils/CustomComponent";

const UseDate = ({
  title,
  field,
  register,
  setValue,
  watch,
  error,
  disable,
  minDate,
  maxDate,
  filter = false,
  blur = false,
  value,
  onFocus = null
}) => {
  const defaultValue = watch(field);
  // const [selectedDate, setSelectedDate] = useState(defaultValue || null);
  const [selectedDate, setSelectedDate] = useState(
    defaultValue && defaultValue !== "undefined" ? defaultValue : null
  );
  useEffect(() => {
    register(field);
  }, [field, register]);

  useEffect(() => {
    if (!selectedDate && defaultValue && defaultValue !== "undefined") {
      setSelectedDate(defaultValue);
    }
  }, [defaultValue, field, selectedDate]);

  useEffect(() => {
    if (value && value !== "undefined" && disable) {
      setValue(field, format(value, "MM/dd/yyyy"));
      setSelectedDate(value);
    }
  }, [value, field, disable]);

  const handleDateChange = (date) => {
    setValue(field, format(date, "MM/dd/yyyy"));
    setSelectedDate(date);
  };

const US_Holidays = [
  {
    date: new Date("01/01/2026"),
    holidayName: "New Year's Day",
  },
  {
    date: new Date("01/19/2026"),
    holidayName: "Martin Luther King Jr. Day",
  },
  {
    date: new Date("02/16/2026"),
    holidayName: "Presidents' Day",
  },
  {
    date: new Date("05/23/2026"),
    holidayName: "Memorial Day",
  },
  {
    date: new Date("06/19/2026"),
    holidayName: "Juneteenth",
  },
  {
    date: new Date("07/04/2026"),
    holidayName: "Independence Day",
  },
  {
    date: new Date("09/07/2026"),
    holidayName: "Labor Day",
  },
  {
    date: new Date("10/12/2026"),
    holidayName: "Columbus Day",
  },
  {
    date: new Date("11/11/2026"),
    holidayName: "Veterans Day",
  },
  {
    date: new Date("11/26/2026"),
    holidayName: "Thanksgiving Day",
  },
  {
    date: new Date("12/25/2026"),
    holidayName: "Christmas Day",
  },
];

  const isWeekdayAndNotHoliday = (date) => {
    const day = date.getDay();
    const holidays = US_Holidays.map((holiday) => holiday.date.toDateString());

    return day !== 0 && day !== 6 && !holidays.includes(date.toDateString());
  };

  return (
    <div className="date-picker-container">
      {blur ? (
        <BlurWrapper>
          <DatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            dateFormat="MM/dd/yyyy"
            placeholderText="mm/dd/yyyy"
            className={`custom-date-picker ${error ? "error" : ""}`}
            // disabled={disable}
            minDate={minDate}
            maxDate={maxDate}
            filterDate={filter ? isWeekdayAndNotHoliday : undefined}
            readOnly={disable}
            onFocus={onFocus}
            holidays={US_Holidays}
          />
        </BlurWrapper>
      ) : (
        <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          dateFormat="MM/dd/yyyy"
          placeholderText="mm/dd/yyyy"
          className={`custom-date-picker ${error ? "error" : ""}`}
          // disabled={disable}
          minDate={minDate}
          maxDate={maxDate}
          filterDate={filter ? isWeekdayAndNotHoliday : undefined}
          readOnly={disable}
          onFocus={onFocus}
          holidays={US_Holidays}
        />
      )}
      <label className={`floating-label ${error ? "error" : ""}`}>
        {title}
      </label>
      {error && (
        <div className="invalid-feedback" style={{ display: "block" }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default UseDate;
